'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    processing: false,
    groups: []
};
//
// function getNumber(value) {
//     if(typeof value === 'number') return value;
//     if(typeof value !== 'string') value = null;
//     value = parseInt(value, 10);
//     if(isNaN(value)) {
//         value = null;
//     }
//     return value;
// }

// import abp from 'abp';

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = state;
    switch (action.type) {
        case _actionTypes2.default.UPDATE:
            newState = (0, _assign2.default)({}, state, { groups: action.facets }, { processing: false });
            break;
        case _actionTypes2.default.CHANGE:
            if (!state.processing) {
                newState = (0, _merge2.default)({}, state);
                var group = newState.groups.find(function (g) {
                    return g.name === action.item.groupName;
                });
                if (group) {
                    var item = group.items.find(function (i) {
                        return i.name === action.item.name;
                    });
                    if (item) {
                        if (typeof action.item.checked === 'boolean') {
                            item.checked = action.item.checked;
                        } else if (typeof action.item.value === 'string') {
                            item.value = action.item.value;
                        }
                        newState.processing = true;
                    }
                }
            }
            break;
    }
    return newState;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/reducer.js
// module id = 1046
// module chunks = 0